import React from 'react';
import { differentiators } from '../../data/company';
import { images } from '../../data/images';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
export function WhyCorventa() {
  return <section className="bg-white py-24 md:py-32" data-id="element-314" data-mp="3d8qzedr9xx40">
      <div className="container-page grid gap-14 lg:grid-cols-12 lg:items-center" data-id="element-315" data-mp="396vyvbh63nra">
        <div className="lg:col-span-5" data-id="element-316" data-mp="9ril23vr9fe1">
          <img src={images.boardroom} alt="An empty executive boardroom overlooking a city skyline at dusk" loading="lazy" className="aspect-[4/5] w-full rounded-xl object-cover" data-id="element-317" data-mp="9qfxo5xn5v2v" />
        </div>
        <div className="lg:col-span-7 lg:pl-8" data-id="element-318" data-mp="sndoogz5z95">
          <SectionHeading kicker="Why Corventa" title="Why organisations choose to work with us." data-id="element-319" data-mp="3rw2g0u2bc7az" />
          <div className="mt-10 space-y-8" data-id="element-320" data-mp="2lhtazlvxwyoc">
            {differentiators.map((d, i) => <Reveal key={d.title} delay={i * 0.04} data-id="element-321" data-mp="2ggx7vajexgjz" data-mpi={i}>
                <div className="grid grid-cols-[20px_1fr] gap-5" data-id="element-322" data-mp="2gkb8ad8infos">
                  <span className="mt-2.5 h-2.5 w-2.5 rotate-45 bg-gold" aria-hidden="true" data-id="element-323" data-mp="1lb7rwfitn9ft" />
                  <div data-id="element-324" data-mp="1q99bd1k5tart">
                    <h3 className="font-display text-2xl font-semibold text-ink" data-id="element-325" data-mp="1q7oozz800y51">{d.title}</h3>
                    <p className="mt-1.5 leading-relaxed text-muted" data-id="element-326" data-mp="1cc46v603gjyo">{d.text}</p>
                  </div>
                </div>
              </Reveal>)}
          </div>
        </div>
      </div>
    </section>;
}